/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type FormCategory = typeof FormCategory[keyof typeof FormCategory];


export const FormCategory = {
  PatientAgreement: 'PatientAgreement',
  PCCConsent: 'PCCConsent',
  ProcedureForm: 'ProcedureForm',
  ReferralOutgoing: 'ReferralOutgoing',
  OrderForm: 'OrderForm',
} as const;
